import axios from 'axios';

const completeReminder = (id, payload) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/reminder/${id}/done`, payload)
    .then(res => res)
    .catch(err => err);
};

export default completeReminder;
